import { EdelmetallBasket } from "./edelmetallBasket";
import { SortenBasket } from "./sortenBasket";
import CONFIG from "../config";

const itemBasket = CONFIG.getShopConfig({
  edelmetall: new EdelmetallBasket(),
  sorten: new SortenBasket()
});

export default itemBasket;